import { useState } from 'react';
import Asistente from './AsistantComponentsView';
import { TestLoginSocial } from './TestLoginSocial';

export const ComponentsView = () => {

    const [showHome, setshowHome] = useState(true);
    const [showLogin, setshowLogin] = useState(true);

    const switchSeat = () => {
        setshowHome(false);
        setshowLogin(false);
    }
    const switchButtons = () => {
        setshowHome(false);
        setshowLogin(false);
    }
    const switchPlanner = () => {
        setshowHome(false);
        setshowLogin(false);
    }
    const switchFormulario = () => {
        setshowHome(false);
        setshowLogin(false);
    }
    const switchHome = () => {
        setshowHome(true);
        setshowLogin(false);
    }
    const switchLogin = () => {
        setshowHome(false);
        setshowLogin(true);
    }

    const emiterButton = (value: string) => {


        switch (value) {
            case 'asientos': switchSeat(); break;
            case 'botones': switchButtons(); break;
            case 'plani': switchPlanner(); break;
            case 'formulario': switchFormulario(); break;
            case 'home': switchHome(); break;
            case 'login': switchLogin(); break;
        }
    }


    return (
        <>
            {
                showHome && (
                    <TestLoginSocial view={'home'} />
                )
            }
            {
                showLogin && (
                    <div className="container my-5">
                        <div className="py-5">
                            <TestLoginSocial view={'login'} />
                        </div>
                    </div>
                )
            }
            <Asistente emiterButton={emiterButton} />
        </>
    )
}
